<template>
  <div class="MyOrder">
    <div class="add">
      <el-button type="primary" plain @click="handleOpen()">
        新增标外商品申请
      </el-button>
    </div>
    <div class="orderBox" v-if="orderList && orderList.length > 0">
      <div class="orderTableHeader">
        <span>状态</span>
        <span>商品名称</span>
        <!-- <span>品牌名称</span> -->
        <span>规格要求</span>
        <span>预计单价</span>
        <!-- <span>详细要求（购买链接）</span> -->
        <span>申请理由采购原因</span>
      </div>
      <ul class="orderList">
        <li v-for="item in orderList" :key="'order' + item.id">
          <div class="orderDetail">
            <span>
              <!-- {{
                item.mx1whh7fbp1ozmov &&
                options.find((el) => el.value === item.mx1whh7fbp1ozmov)
                  ? options.find((el) => el.value === item.mx1whh7fbp1ozmov)
                      .label
                  : ''
              }} -->
              {{ findStatusLabel(item.mx1whh7fbp1ozmov) }}
            </span>
            <div class="goodsName">
              <p>
                {{ item.yweggjdjennwlx2b }}
              </p>
            </div>
            <!-- <span>{{ item['2uxq3bkljctevagu'] }}</span> -->
            <span>{{ item.okxizq5fy7x1v2pj }}</span>
            <span>{{ item.wxym5do3isvbzeth }}</span>
            <!-- <span>{{ item['5wzakr37o7owu4qj'] }}</span> -->
            <span>{{ item['g9llk5yvei0jvr6x'] }}</span>
          </div>
        </li>
      </ul>
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page"
          :page-sizes="[10, 20, 40, 80]"
          :page-size="limit"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
    <p class="emptyTips" v-else>
      <img src="../../assets/img/order.svg" alt="" />
    </p>
    <el-dialog
      title="新增标外商品申请"
      :visible.sync="dialogVisible"
      width="800px"
      :show-close="false"
    >
      <el-form
        ref="form"
        :model="form"
        label-width="80px"
        label-position="left"
      >
        <el-row>
          <el-col :span="12">
            <el-form-item label="收货人">
              <el-select
                v-model="form.orac6eyyydzpco13"
                placeholder="请选择"
                @change="changeAddress"
                filterable
              >
                <el-option
                  v-for="item in addressList"
                  :key="item.id"
                  :label="item.mdbcej4opshigmrs"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="联系方式">
              <el-input
                v-model="form.etnsg3kbzcknkawr"
                disabled
                placeholder="请输入"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="所在地区">
              <el-cascader
                disabled
                v-model="form.glhztcnef0v5zdcy"
                :options="city"
                :props="props"
                placeholder="请选择省市区"
              ></el-cascader>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="详细地址">
              <el-input
                v-model="form['5swsm1dvrchwdg3v']"
                disabled
                placeholder="请输入"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="商品名称" required>
              <el-input
                v-model="form.yweggjdjennwlx2b"
                placeholder="请输入"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="品牌名称">
              <el-input
                v-model="form['2uxq3bkljctevagu']"
                placeholder="请输入"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="规格要求">
              <el-input
                v-model="form.okxizq5fy7x1v2pj"
                placeholder="请输入"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="预计单价" required>
              <el-input
                v-model="form.wxym5do3isvbzeth"
                placeholder="请输入"
                type="number"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="数量" required>
              <el-input
                v-model="form['2lcyfkgbyjmfmedh']"
                placeholder="请输入"
                type="number"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="详细要求(购买链接)">
              <el-input
                v-model="form['5wzakr37o7owu4qj']"
                placeholder="请输入"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="申请理由采购原因" required>
              <el-input
                v-model="form.g9llk5yvei0jvr6x"
                placeholder="请输入"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="商品图片">
              <div class="fileList">
                <div
                  class="fileItem"
                  v-for="(item, index) in file"
                  :key="index"
                >
                  <div class="close" @click="handleRemove(item)">
                    <img src="../../assets/img/delete.png" alt="" />
                  </div>
                  <img :src="item.url" alt="" class="url" />
                </div>
                <div class="fileItem">
                  <el-upload
                    :action="action"
                    list-type="picture-card"
                    :on-remove="handleRemove"
                    :file-list="file"
                    :show-file-list="false"
                    :on-success="handleSuccess"
                  >
                    <i class="el-icon-plus"></i>
                  </el-upload>
                </div>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submit()">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Popup from "../../components/Popup";
import { online, postOnline } from "@/api/platform";
import city from '@/util/city'
export default {
  name: "MyOrder",
  components: {
    Popup,
  },
  computed: {
    ...mapState(["clientToken"]),
  },
  data () {
    return {
      id: '',
      form_head_uuid: "d098b98521634ac7aac59d4d4ed249e6",
      orderList: [],
      keyword: '',
      //分页
      page: 1,
      total: 0,
      limit: 20,
      // 弹窗
      file: [],
      dialogVisible: false,
      action: 'https://api.ontuotu.com/api/general/upload',
      form: {},
      addressList: [],
      city,
      props: {
        label: 'name',
        value: 'id'
      },
      options: [
        { label: "待总集复核", value: "a9aa18ff-1f2c-46a3-b816-1ed227d960b6" },
        { label: "审批中", value: "52efb014-07cf-41ec-8407-13e151f95da6", },
        { label: "审批成功", value: "7c970bbb-0744-4f99-813b-d7bd98188a71", },
        { label: "审批驳回", value: "1a5b7046-c33d-42c1-92ef-35e5cea1a9a2", }
      ]
    };
  },
  mounted () {
    this.getOrderList();
    this.online()
    // this.relationRows()
  },
  methods: {
    findStatusLabel (value) {
      if (value) {
        return this.options.find(item => item.value === value).label || ''
      } else {
        return ''
      }
    },
    async online () {
      const { result } = await online({
        page: 1,
        limit: 100,
        keyword: '',
        select_option: '',
        form_head_uuid: '0f5b2fde26c04882a5d6c5c885a30a3f',
      })
      this.addressList = result
    },
    changeAddress (e) {
      let obj = this.addressList.find(item => item.id === e);
      console.log(obj);
      this.form.etnsg3kbzcknkawr = obj.xejhteu0ub3fd3eh || ''
      this.form['5swsm1dvrchwdg3v'] = obj['9simp0sjii9s0m33'] || ''
      this.form.glhztcnef0v5zdcy = obj.b3ccmzbfyzlwy9sc.map(el => el.id)
    },
    // 获取订单列表
    async getOrderList () {
      const { form_head_uuid, page, limit } = this;
      const { meta, result } = await online({
        form_head_uuid,
        page,
        limit,
        keyword: "",
        select_option: "",
      });
      this.orderList = result;
      this.total = meta.total;
    },
    // 切换页数
    handleCurrentChange (page) {
      this.page = page;
      this.getOrderList();
    },
    handleSizeChange (limit) {
      this.page = 1;
      this.limit = limit;
      this.getOrderList();
    },
    navTo (route) {
      this.$router.push(route);
    },
    // 新增标外商品申请
    handleOpen () {
      this.form = {}
      this.file = []
      this.dialogVisible = true
    },
    handleSuccess ({ result }) {
      this.file.push(result)
    },
    handleRemove (file) {
      let i = this.file.findIndex(el => el.id === file.id);
      this.file.splice(i, 1);
    },
    // 提交
    async submit () {
      const { form, file } = this
      const validations = [
        { field: 'yweggjdjennwlx2b', error: '请输入商品名称' },
        { field: 'wxym5do3isvbzeth', error: '请输入预计单价' },
        { field: '2lcyfkgbyjmfmedh', error: '请输入数量' },
        { field: 'g9llk5yvei0jvr6x', error: '请输入申请理由采购原因' },
      ];
      for (const { field, error } of validations) {
        if (!form[field]) {
          return this.$notify.error({ title: '提示', message: error });
        }
      }
      const { form_head_uuid } = this;
      if (file && file.length > 0) {
        form.xrsnsamzcsuibskx = file.map(el => el.id)
      }
      await postOnline({
        form_head_uuid,
        ...this.form,
      })
      this.dialogVisible = false
      this.page = 1;
      this.getOrderList();

    }
  },
};
</script>

<style scoped lang="less">
@import '../../assets/css/var.less';
.MyOrder {
  .tagList {
    li {
      text-align: center;
      display: inline-block;
      font-weight: 550;
      font-size: 18px;
      border-bottom: 2px solid @borderColor;
      cursor: pointer;
      padding: 10px 20px;
      position: relative;
      &:after {
        top: 12px;
        right: 0;
        position: absolute;
        content: '';
        width: 1px;
        height: 15px;
        background-color: @borderColor;
      }
      &:last-child {
        &:after {
          display: none;
        }
      }
    }
    .selected {
      color: @thirdColor;
      border-bottom: 2px solid @thirdColor;
    }
  }
  .orderBox {
    width: 100%;
    margin-top: 20px;
    .orderTableHeader {
      width: 100%;
      height: 40px;
      background-color: #f5f5f5;
      border: 1px solid @borderColor;
      color: @fontDefaultColor;
      font-size: 14px;
      line-height: 40px;
      display: flex;
      justify-content: flex-start;
      span {
        flex: 1;
        line-height: 40px;
        padding-left: 10px;
      }
    }
    .orderList {
      width: 100%;
      li {
        border: 1px solid @borderColor;
        font-size: 13px;
        margin-top: 10px;
        .orderDetail {
          width: 100%;
          padding: 10px 0;
          position: relative;
          display: flex;
          // justify-content: flex-start;
          .goodsName {
            flex: 1;
            padding-left: 10px;
            box-sizing: border-box;
          }
          span {
            flex: 1;
            word-break: break-all;
            padding-left: 10px;
          }
        }
      }
    }
    .pagination {
      display: flex;
      justify-content: flex-end;
      margin: 20px 0 0;
    }
  }
}
.el-select,
.el-cascader {
  width: 100%;
}
.emptyTips {
  text-align: center;
  margin: 200px auto;
}
/deep/.el-row {
  .el-col-12 {
    &:nth-child(2) {
      padding-left: 5px;
    }
  }
  .el-col-24 {
    .el-form-item__label {
      width: 100% !important;
    }
    .el-form-item__content {
      margin-left: 0 !important;
      margin-top: 40px;
    }
  }
}
.fileList {
  display: flex;
  .fileItem {
    width: 148px;
    height: 148px;
    margin: 0 10px 10px 0;
    position: relative;

    .url {
      width: 100%;
      height: 100%;
      border-radius: 6px;
    }
    .close {
      position: absolute;
      right: 5px;
      top: 5px;
      // width: 15px;
      // height: 15px;
      cursor: pointer;
      background: rgba(0, 0, 0, 0.5);
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 4px;
      border-radius: 3px;
      img {
        width: 15px;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/client/CommodityApplication.vue